import { Suspense, useState } from 'react';
import { Icon, Text } from '~/components/atomic';
import { IconButtonWrapper } from '~/components/common';
import CreatorTag from '~/components/common/CharacterCard/CreatorTag/CreatorTag';
import { GetCommentData } from '~/types';
import BottomSheetContainer from '../common/BottomSheet/BottomSheet';
import * as S from './CommentContainer.styled';
import CommentInner from './CommentInner/CommentInner';

export interface CommentProps {
  viewComment: {
    total: number;
    writer?: string;
    content?: string;
  };
  isMissionGame?: boolean;
}

export default function CommentContainer({
  viewComment,
  isMissionGame,
}: CommentProps) {
  const [isCommentOpen, setIsCommentOpen] = useState(false);
  const [commentInputState, setCommentInputState] = useState<string>('');
  const [editingComment, setEditingComment] = useState<GetCommentData | null>(
    null,
  );
  const isEditMode = editingComment !== null;

  return (
    <>
      <S.Container
        onClick={() => {
          setIsCommentOpen(true);
          setCommentInputState('');
        }}
      >
        <S.TopWrapper>
          <Text fontStyle='poppins.desc' color='content_light_1'>
            Comments {!!viewComment?.total && viewComment.total}
          </Text>
          <IconButtonWrapper size={16}>
            <Icon iconName='ArrowRight' size={16} color='content_light_5' />
          </IconButtonWrapper>
        </S.TopWrapper>

        {viewComment.writer ? (
          <S.CommentTagWrapper>
            <CreatorTag create_username={viewComment.writer} />
            <S.EllipsisText
              fontStyle='text.body14_medium'
              color='content_light_1'
            >
              {viewComment.content}
            </S.EllipsisText>
          </S.CommentTagWrapper>
        ) : (
          <S.CommentWrapper>
            <Text fontStyle='text.body14_medium' color='content_light_5'>
              Add a comment
            </Text>
          </S.CommentWrapper>
        )}
      </S.Container>

      <BottomSheetContainer
        isOpen={isCommentOpen}
        onClose={() => {
          setIsCommentOpen(false);
        }}
        openHeightRates={[0.8]}
      >
        <Suspense fallback={null}>
          <CommentInner
            commentInputState={commentInputState}
            commentCount={viewComment?.total}
            editingComment={editingComment}
            isCommentOpen={isCommentOpen}
            setIsCommentOpen={setIsCommentOpen}
            setCommentInputState={setCommentInputState}
            setEditingComment={setEditingComment}
            isEditMode={isEditMode}
            isMissionGame={isMissionGame}
          />
        </Suspense>
      </BottomSheetContainer>
    </>
  );
}
